/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Versioned organization-wide settings delivered to enrolled device agents. Agents must ignore unknown config keys. Remote settings override the shareable local/MDM settings after a successful fetch; per-device identity and secrets always remain local.
 */
export type DeviceAgentConfiguration = {
  /**
   * Forward-compatible non-secret settings document. Platform values use false, user, or managed enforcement layers.
   */
  config: { [k: string]: any };
  /**
   * Opaque revision identifier for this configuration.
   */
  etag: string;
  /**
   * Whether an administrator has saved a remote configuration. False means agents should not add a remote resolver layer.
   */
  isConfigured: boolean;
  /**
   * Schema version for this remote configuration envelope.
   */
  schemaVersion: number;
  /**
   * When this remote configuration was last saved. Absent when is_configured is false.
   */
  updatedAt?: Date | undefined;
};

/** @internal */
export const DeviceAgentConfiguration$inboundSchema: z.ZodMiniType<
  DeviceAgentConfiguration,
  unknown
> = z.pipe(
  z.object({
    config: z.record(z.string(), z.any()),
    etag: z.string(),
    is_configured: z.boolean(),
    schema_version: z.int(),
    updated_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "is_configured": "isConfigured",
      "schema_version": "schemaVersion",
      "updated_at": "updatedAt",
    });
  }),
);

export function deviceAgentConfigurationFromJSON(
  jsonString: string,
): SafeParseResult<DeviceAgentConfiguration, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeviceAgentConfiguration$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeviceAgentConfiguration' from JSON`,
  );
}
